module.exports = __webpack_public_path__ + "media/images/flags/32/Mauritania-71d634fe528702c22a7e1b58c1f9c8b0.png";